'use strict';

var angular = require('angular');
var GridDrawerDirective = function GridDrawerDirective($document) {
  return {
    restrict: 'E',
    controller: 'GridDrawerController',
    require: '^rmGridPanel',
    template: require('../templates/grid-drawer.html'),
    link: function link($scope, element) {
      $scope.reOpenDrawerOnTransitionEnd = function (mode) {
        element.find('.grid-drawer').one('transitionend', function () {
          $scope.openDrawer(mode);
          $scope.$apply();
        });
      };
      function hideOnWindowClick(event) {
        var targetElement = angular.element(event.target);
        var rmModalElement = targetElement.parents('rm-modal');
        var isBusyOverlay = targetElement.hasClass('busy-indicator-overlay');
        var clickOutsideOfDrawer = angular.element(event.target).closest(element).length === 0;
        var isRuleModalView = rmModalElement.size() && rmModalElement.attr('modal-id') === 'rule-visualize';
        if ($scope.isDrawerVisible && !isBusyOverlay && clickOutsideOfDrawer && !isRuleModalView) {
          $scope.hideDrawer();
          $scope.$apply();
        }
      }
      $document.on('mousedown', hideOnWindowClick);
      element.on('$destroy', function () {
        $document.off('mousedown', hideOnWindowClick);
      });
      $scope.$on('grid:hideDrawer', $scope.hideDrawer);
      $scope.$on('grid:rowSelectionChanged', $scope.onRowSelectionChanged);
      $scope.$on('grid:hideDrawerAndSetReopenFlag:' + $scope.gridId, $scope.hideDrawerAndSetReopenFlag);
      $scope.$on('comments:updated', function (event, count) {
        $scope.commentsCount = count;
      });
    }
  };
};
GridDrawerDirective.$inject = ['$document'];
module.exports = GridDrawerDirective;